import { Component, OnInit, ViewEncapsulation, Renderer2, Injectable, ElementRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AdminService } from 'src/app/core/services/admin.service';
import { LearnerService } from 'src/app/core/services/learner.service';
import { LoginService } from 'src/app/core/login/login.service';
import { LoaderService } from 'src/app/core/services/loader.service';
import { ActionPopupComponent } from 'src/app/components/action/action.component';
import { Router, RouterLink } from '@angular/router';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { ToastrService } from 'ngx-toastr';
import { PermissionService } from 'src/app/core/services/permission-service.service';
import { SidebarService } from 'src/app/core/services/sidebar.service';
import { filter, take } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { getFirestore, doc, getDoc } from 'firebase/firestore';
import { getApp } from 'firebase/app';
import { OffsiteEligibilityService } from 'src/app/core/services/offsite-eligibility.service';
@Injectable({
  providedIn: 'root'
})
@Component({
  selector: 'all-links',
  templateUrl: './all-links.component.html',
  styleUrls: ['./all-links.component.scss'],
  encapsulation: ViewEncapsulation.None,



})
export class AllLinksComponent implements OnInit {
  appraisalURL:string = environment.appraisalUrl;
  isAdmin: boolean = false;
  user: any;
  lndUserType: any;
  dates: any;
  documents: any;
  name: any;
  setAttribute: any;
  htmlToAdd: string;
  checked = false;
  startDate = new Date(2018, 2, 12);
  ogDate = new Date(1990, 0, 1);
  specialDates = [];
  isHome:Boolean=false;
  isExpense: Boolean=false;
  isHr: Boolean=false;
  isEmotionalwellbeing:Boolean=false;
  isRewardsrecognition:Boolean=false;
  isPayrollcompensation:Boolean=false;
  isAppraisalengine:Boolean=false;
  isLnd:Boolean=false;
  isOffsite:Boolean=false;
  offsiteFormActive: boolean = false;
  docRes: any;
  holidayList: any;
  sidebarCollapsed: boolean = false;
  upcomingHolidays: any;
  Holidays: any
  optionalHolidays: any;
  currentDate: Date;
  event: any;
  currentMonthLastDate: Date;
  holidayDate: any;
  currentDates: Date = new Date();
  currentYear: any;
  isPickerOpen = false;
  holidaydates: any;
  currentDateWithoutTime: any;
  holidayDateWithoutTime: any;
  holidaysForCurrentYear: any;
  threeMonthsLater: Date;
  currentMonth: any;
  payrollURL:string;
  ewa_url:string;
  cards = [
    {
      id: 1,
      title: 'L&D Manager',
      description: 'Learning & Development (L&D) delivers to the changing needs of organizations & level-up investment in professional development. Explore new sessions, register for upcoming sessions, provide feedback & experience a smooth L&D experience.',
      accessibility: 'Open to all on-roll & off-roll employees.',
      onClick: () => this.openLnd(),
      hasAccess: () => this.isLnd
    },
    {
      id: 2,
      title: 'Appraisal Engine',
      description: 'Appraisals empower all-encompassing assessment & feedback to develop an engaging high-performance org culture. Experience a streamlined, digital appraisal workflow.',
      accessibility: 'Open to all on-roll & off-roll employees.',
      onClick: () => this.openAppraisal(),
      hasAccess: () => this.isAppraisalengine
    },
    {
      id: 3,
      title: 'Payroll & Compensation',
      description: 'Through our Taxation & Payroll partner, manage all things taxes & salary.',
      accessibility: 'Open only to on-roll employees.',
      onClick: () => this.opengreytHR(),
      hasAccess: () => this.isPayrollcompensation
    },
    {
      id: 4,
      title: 'Rewards & Recognition',
      description: 'Enabled by Vantage Circle, recognize your peers for their exemplary work & foster meaningful connections through innovative recognition & wellness solutions.',
      accessibility: 'Open to all on-roll & off-roll employees.',
      onClick: () => this.openVantageCircle(),
      hasAccess: () => this.isRewardsrecognition
    },
    {
      id: 5,
      title: 'Emotional Well-being Assistance',
      description: 'Enabled by 1to1Help, Amplus brings to you and your family a 24X7 available counseling platform to address the increased issues of emotional well-being. Explore assessments, podcasts, articles, videos, and webinars focusing on psychological safety and emotional well-being.',
      accessibility: 'Open to all on-roll & off-roll employees.',
      onClick: () => this.openEWA(),
      hasAccess: () => this.isEmotionalwellbeing
    },

    {
      id: 6,
      title: 'Expense Manager',
      description: 'Through this Hr or authorised personnel can manage all claims and Expenses.',
      accessibility: 'Open only to amplus employees.',
      onClick: () => this.openExpenseManager(),
      hasAccess: () => this.isExpense
    },
    {
      id: 7,
      title: 'HR Manager',
      description: 'Through this Hr or authorised personnel can manage all Holiday,Leaves and Events.',
      accessibility: 'Open only to amplus employees.',
      onClick: () => this.openHrManager(),
      hasAccess: () => this.isHr
    },
    {id: 8,
      title: 'New Offsite 2026 Registration',
      description: 'Register for the Annual Offsite 2026 event. Confirm your attendance, provide meal preferences, room allocation choices, and travel details for this team bonding experience.',
      accessibility: 'Open to all on-roll and off-roll employees greater than one year of experience as on 31st March 2026.',
      onClick: () => this.openOffsite(),
      hasAccess: () => this.isOffsite && this.offsiteFormActive
      // hasAccess: () => true,
    },

  ];

  constructor(
    private learnerService: LearnerService,
    private adminService: AdminService,
    private dialog: MatDialog,
    private msalService: LoginService,
    private router: Router,
    private renderer: Renderer2,
    private el: ElementRef,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private toastr: ToastrService,
    private permissionService:PermissionService,
    private sidebarService: SidebarService,
    private offsiteEligibility: OffsiteEligibilityService
  ) {
    this.matIconRegistry.addSvgIconSet(
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../../assets/images/arrow.svg')
    );
  }

  ngOnInit() {
    // Subscribe to sidebar collapsed state
    this.sidebarService.collapsed$.subscribe(collapsed => {
      this.sidebarCollapsed = collapsed;
    });

    this.loadOffsiteConfig();

   
    this.learnerService.getUserType().subscribe(res => {
      this.user = res['lnd_user_type'];
      this.lndUserType = true;
      localStorage.setItem('user_type', res['lnd_user_type']);
    },
      (error: any) => {
        console.log(error, error.error, error.message);
        if (error.error == 'Signature has expired') {
          this.msalService.logout();
        }
      });
    this.isAdmin = localStorage.getItem('user_type') == 'admin' ? true : false;
    this.name = localStorage.getItem('name');
    this.learnerService.getHolidayList().subscribe(res => {
      this.dates = res['data'];
      this.holidayList = this.dates;
      this.filterUpcomingHolidays();

    },
      (error: any) => {
        console.log(error, error.error, error.message);

      });

   // calling permissions service and setting permissions  
    this.permissionService.getEmployeePermissions()
    .pipe(
       filter(data => !!data),
       take(1)
    )
    .subscribe(empPerms => {
      if (empPerms) {
          this.isExpense=empPerms.expense_manager;
          this.isHome=empPerms.home;
          this.isHr = empPerms.hr_manager;
          this.isEmotionalwellbeing = empPerms.emotional_wellbeing;
          this.isRewardsrecognition=empPerms.rewards_recognition;
          this.isPayrollcompensation=empPerms.payroll_compensation;
          this.isAppraisalengine=empPerms.appraisal_engine;
          this.isLnd=empPerms.lnd;
          // Offsite eligibility is determined from employee data below

      }
    });


 this.permissionService.getEmployeeData().subscribe(empData => {
      if (empData) {
         this.payrollURL=empData.payroll_url;
         this.ewa_url=empData.ewa_url;

         // Offsite 2026 eligibility check:
         // 1. On-roll Gentari India employees
         // 2. Off-roll who completed 1 year as on 31st March 2026
         // 3. Off-roll at HO (Head Office) regardless of tenure
         this.isOffsite = this.checkOffsiteEligibility(empData);

      }
    })
    
  }

  isLoggedIn(): boolean {
    return this.msalService.isLoggedIn();
  }

  logout() {
    this.closeNav();
    let dialogRef = this.dialog.open(ActionPopupComponent, {
      width: "300px",
      data: {
        buttontext: "Log Out",
        desc: "Do you want to Log Out?",
      },
    });
    const sub = dialogRef.componentInstance.option.subscribe((data) => {
      if (data) {
        sub.unsubscribe();
        if (data == "success") {
          this.isLoggedIn();
          this.msalService.logout();
        }
      }
    });

  }

  // getToken(): any {
  //   return this.msalService.getToken();

  // }
  openLnd() {
  
    this.router.navigate(['learning-and-development']);
  }

  openExpenseManager() {
    this.router.navigate(['expense-manager/all-claim']);
  }
  openHrManager() {

    this.router.navigate(['hr-manager']);
  }
  amplusPoa() {
    this.router.navigate(['/poa/view_poa'], {
      queryParams: {
        value: 'action'
      }
    });
  }



  openAppraisal() {
     window.open(this.appraisalURL, "_blank");
  }
  opengreytHR() {
    window.open(this.payrollURL, "_blank");
  }

  openVantageCircle() {
    window.open('https://gentari.vantagecircle.com/', "_blank");
  }

  openEWA() {
    window.open(this.ewa_url, "_blank");
  }

  employeeDocuments() {
    this.router.navigate(['employee-documents']);

  }


  openNav() {
    document.getElementById("mySidenav").style.width = "300px";

    document.getElementById("fullPageOverLay").style.display = "block";
  }

  closeNav() {
    document.getElementById("mySidenav").style.width = "0";
    document.getElementById("fullPageOverLay").style.display = "none";
  }


  openSubMenu: string | null = null; // Stores the identifier of the currently open submenu

  toggleSubMenu(menuId: string): void {
    if (this.openSubMenu === menuId) {
      this.openSubMenu = null;
    } else {
      this.openSubMenu = menuId;
    }
  }

  isSubMenuOpen(menuId: string): boolean {
    return this.openSubMenu === menuId;
  }

  home() {
    this.router.navigate(['home']);

  }
  amplusProduct() {
    this.router.navigate(['products']);

  }

  amplusMemories() {
    this.router.navigate(['memories']);

  }
  amplusCircular() {
    this.router.navigate(['circular']);
  }
  amplusGuidelinesPolicy() {
    this.router.navigate(['guidelines-policy']);
  }

  offRollLeaveLop() {
    this.router.navigate(['lop-management']);
  }

  employeeOnboarding() {
    this.router.navigate(['hr-home']);

  }

  openOffsite() {
    this.router.navigate(['offsite-registration']);
  }

  loadOffsiteConfig(): void {
    try {
      const db = getFirestore(getApp());
      const currentYear = new Date().getFullYear().toString();
      const configRef = doc(db, 'config', currentYear);
      getDoc(configRef)
        .then((snap) => {
          if (snap.exists()) {
            const data = snap.data();
            this.offsiteFormActive = data['form_active'] === true;
          } else {
            this.offsiteFormActive = false;
          }
        })
        .catch((err) => {
          console.error('[AllLinks] Failed to fetch offsite config:', err);
          this.offsiteFormActive = false;
        });
    } catch (err) {
      console.error('[AllLinks] Firebase not initialized:', err);
      this.offsiteFormActive = false;
    }
  }

  getDocument(docres: any) {
    this.docRes = docres
  }

  filterUpcomingHolidays(): void {
    this.currentDate = new Date();
    this.currentMonth = this.currentDate.getMonth();
    this.currentYear = this.currentDate.getFullYear();
    this.currentDateWithoutTime = this.getDateWithoutTime(this.currentDate);
    this.currentMonthLastDate = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth() + 1, 0);
    this.threeMonthsLater = new Date(this.currentYear, this.currentMonth + 3, 0);

    this.upcomingHolidays = this.holidayList
      .filter(holiday => {
        this.holidayDateWithoutTime = this.getDateWithoutTime(new Date(holiday.date));
        return this.holidayDateWithoutTime >= this.currentDateWithoutTime && holiday.type == 0;
      })
      .slice(0, 5);

    this.holidaysForCurrentYear = this.holidayList.filter(holiday => {
      const holidayDate = new Date(holiday.date);
      return holidayDate.getFullYear() === this.currentYear;
    });

    // console.log(this.holidaysForCurrentYear);
    this.Holidays = this.holidaysForCurrentYear
      .filter(holiday => {
        return holiday.type == 0;
      });

    this.optionalHolidays = this.holidaysForCurrentYear
      .filter(holiday => {
        return holiday.type == 2;
      });

    this.event = this.holidayList
      .filter(holiday => {
        this.holidayDate = new Date(holiday.date);
        this.holidayDateWithoutTime = this.getDateWithoutTime(this.holidayDate);
        return (this.holidayDateWithoutTime >= this.currentDateWithoutTime &&
          this.holidayDateWithoutTime <= this.getDateWithoutTime(this.threeMonthsLater)) &&
          holiday.type == 3;
      });

    this.holidaydates = this.holidayList
      .filter(holiday => holiday.type == 3);
  }

  getDateWithoutTime(date: Date): Date {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
  }


  getCurrentMonth(): string {
    return this.currentDates.toLocaleDateString('en-US', { month: 'short' });
  }


  extractUrls(description: string): string[] {
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    return description.match(urlRegex) || [];
  }

  processDescription(description: string): string {
    return description.replace(/(https?:\/\/[^\s]+)/g, '');
  }

  copyImage(imageUrl: string) {
    navigator.clipboard.writeText(imageUrl)
      .then(() => {
        this.toastr.success(imageUrl, 'linked copied successfully');
      })
      .catch((err) => {
        this.toastr.success(imageUrl, 'failed to copied ');
      });
  }



  getAccessibleCards() {
    return this.cards.filter(card => {
      if (card.hasAccess) {
        return card.hasAccess();
      }
      return true;
    });
  }
 /**
   * Offsite 2026 Eligibility:
   * Only employees explicitly included in the HR-provided email allowlist can access the form.
   */
  private checkOffsiteEligibility(empData: any): boolean {
    if (!empData) {
      console.log('[Offsite Eligibility] No employee data available');
      return false;
    }

    const employeeEmail = this.offsiteEligibility.getEmployeeEmail(empData);
    const isEmailAllowlisted = this.offsiteEligibility.isAllowlisted(empData);

    console.group('[Offsite Eligibility] Check');
    console.log('Employee:', empData.first_name, empData.last_name, empData.company, `(${empData.emp_id || empData.employee_code})`);
    console.log('email:', employeeEmail, '| allowlisted:', isEmailAllowlisted);

    if (isEmailAllowlisted) {
      console.log('ELIGIBLE - Email allowlist');
      console.groupEnd();
      return true;
    }

    console.log('NOT ELIGIBLE - Email not present in offsite allowlist');
    console.groupEnd();
    return false;
  }

}
